import {IBaseSchema} from '../base.schema';

export type PermissionScope = 'Survey';

export interface IPermission extends IBaseSchema {
    name: string;

    scope: string;

    actions: string[];

    effect: Effect;

    resources: string[];

    condition?: string;

    /**
     * System ones are hidden to user
     */
    system?: boolean;
}

export interface IPermissionCreate extends Omit<IPermission, '_id'> {}
export interface IPermissionActivate extends Pick<IPermission, '_id' | 'active'> {}

export interface IPermissionTable extends Pick<IPermission, 'name' | 'active'> {
    _id: string;
}

export interface IPermissionSelect extends Pick<IPermission, '_id' | 'name'> {
    _id: string;
}

export enum Effect {
    Allow = 'Allow',
    Deney = 'Deney',
}
